// 1. 외부 패키지
import { Suspense } from "react";


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import Left from "./left";


// 4. 타입


const LeftWrapper = () => {
	return (
		<Suspense
			fallback={
				<div className="left skeleton" style={{ aspectRatio: "778 / 465" }} />
			}
		>
			<Left />
		</Suspense>
	);
}

export default LeftWrapper;